var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"missing-product"},[_vm._v(" "+_vm._s(_vm.msg ? _vm.msg : 'Missing Product/s')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }